
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Migration & Strategy',
      description: 'Seamlessly migrate your infrastructure to the cloud with our expert guidance. We help you choose the right cloud platform and optimize costs.',
      features: ['AWS, Azure, GCP expertise', 'Cost optimization', 'Security compliance', '24/7 monitoring']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity Solutions',
      description: 'Protect your business from cyber threats with comprehensive security assessments, implementation, and ongoing monitoring.',
      features: ['Security audits', 'Threat detection', 'Compliance management', 'Employee training']
    },
    {
      icon: 'ri-rocket-line',
      title: 'Digital Transformation',
      description: 'Modernize your business processes and technology stack to stay competitive in the digital age.',
      features: ['Process automation', 'Legacy system modernization', 'Digital strategy', 'Change management']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'IT Infrastructure Optimization',
      description: 'Optimize your existing IT infrastructure for better performance, reliability, and cost-effectiveness.',
      features: ['Performance tuning', 'Network optimization', 'Server consolidation', 'Disaster recovery']
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Software Development Consulting',
      description: 'Get expert advice on software architecture, technology selection, and development best practices.',
      features: ['Architecture design', 'Technology selection', 'Code reviews', 'Development processes']
    },
    {
      icon: 'ri-global-line',
      title: 'Websites & AI Automation for SMEs',
      description: 'Custom websites and AI automation solutions designed specifically for small medical practices like dental and veterinary clinics.',
      features: ['Professional websites', 'Online appointment booking', 'AI chatbots for patient inquiries', 'Automated patient reminders']
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'IT Strategy & Planning',
      description: 'Develop comprehensive IT strategies aligned with your business goals and future growth plans.',
      features: ['Strategic planning', 'Technology roadmaps', 'Budget planning', 'Risk assessment']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Expert IT Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive IT consulting services to help your business thrive in the digital landscape
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-emerald-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <div className="w-4 h-4 flex items-center justify-center mr-3">
                      <i className="ri-check-line text-emerald-600"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
